angular.module("vgresiduos").directive("disposalTransporter", function () {
	return {
		scope: true,
		controller: "DisposalTransporterCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/steps/disposalTransporter/disposalTransporter_template.html"
	};
});
